<template>
  <div
    data-testid="checks-all-panel"
    class="tw-pb-4 tw-px-6 tw-flex tw-flex-col tw-gap-4"
  >
    <RemarkGroup
      v-if="generalCheckIds.length > 0"
      :name="I18n.t('assistant_check.page.sections.general')"
      :show-mark-as-read="false"
      disable-mark-as-read
    >
      <SfAssistantCheck
        v-for="checkId in generalCheckIds"
        :key="checkId"
        :check="assistantChecksById[checkId]"
        :read="checkReadStatus[checkId]"
        :read-by-users="checkReadByUsers[checkId]"
      />
    </RemarkGroup>
    <RemarkGroup
      v-for="workflow in hierarchy"
      :key="workflow.id"
      :name="workflowById[workflow.id].name"
      :show-mark-as-read="false"
      disable-mark-as-read
    >
      <template v-for="context in workflow.children">
        <SfAssistantCheck
          v-for="checkId in groupedCheckIds[workflow.id][context.id]"
          :key="checkId"
          :check="assistantChecksById[checkId]"
          :read="checkReadStatus[checkId]"
          :read-by-users="checkReadByUsers[checkId]"
        />
      </template>
    </RemarkGroup>
    <div
      class="
        tw-mx-auto
        tw-my-4
        tw-font-medium
        tw-text-sm
        tw-text-sf-gray-light
        tw-text-center
      "
    >
      {{ I18n.t('assistant_check.page.checks.no_more') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { storeToRefs } from 'pinia'
import RemarkGroup from '@app/application/communication/screens/inbox/components/remark-group.vue'
import SfAssistantCheck from '@app/application/sf-assistant-checks/components/sf-assistant-check.vue'
import { useSfAssistantChecksPage } from '../stores/page'
import { useAssistantChecksStore } from '../stores/assistant-checks'

const I18n = useI18n()

const pageStore = useSfAssistantChecksPage()
const assistantChecksStore = useAssistantChecksStore()

const {
  checkReadStatus,
  checkReadByUsers,
  groupedCheckIds,
  hierarchy,
  workflowById,
  generalCheckIds,
} = storeToRefs(pageStore)

assistantChecksStore.initFromPageStore()

const assistantChecksById = storeToRefs(assistantChecksStore).assistantChecks
</script>

<style scoped>
.remark-group {
  --sf-remark-group-sticky-offset: 16px;
}
</style>
